import gql from 'graphql-tag';

export const GET_RESERVES_LIST = gql`
    query ($member_no: ID!, $limit: Int, $offset: Int) {
        GetReserveListByMemberNo(
          member_no: $member_no,
          limit: $limit,
          offset: $offset
        )
        {
        ReserveList {
            reserve_no
            member_no
            play_date
            golf_code
            golf_name
            plan_name
            play_number
            reserve_situation
            reserve_type
        }
        count
        #   result
        #   resultText
        }
    }
`;

export const GET_MY_PAGE_RESERVES_LIST = gql`
    query ($member_no: ID!, $reserve_type: Int!, $limit: Int, $offset: Int) {
        GetReserveListByMyPage(
          member_no: $member_no,
          reserve_type: $reserve_type,
          limit: $limit,
          offset: $offset
        )
        {
        ReserveList {
            reserve_no
            member_no
            play_date
            golf_code
            golf_name
            plan_id
            plan_name
            play_number
            reserve_situation
            reserve_type
            course_name
            play_start
            cell_number
            play_together_fixed_deadline
            play_style {
                    some_code
                    round_code
                    cart_code
                    cart_on
                    cart_off
                    caddie_flag
                    meal_flag
                    accommodation_flag
                    competition_flag
                    through_flag
                    lesson_flag
                    reserve_type
                    plan_id
                    reserve_situation
            }
        }
        count
        #   result
        #   resultText
        }
    }
`;

export const GET_MY_PAGE_RESULT_LIST = gql`
    query ($member_no: ID!, $limit: Int, $offset: Int) {
        GetResultListByMyPage(
          member_no: $member_no,
          limit: $limit,
          offset: $offset
        )
        {
        ReserveList {
            reserve_no
            member_no
            play_date
            golf_code
            golf_name
            class_no
            play_number
            total_fee
        }
        count
        }
    }
`;


export const GET_RESERVE = gql`
    query ($reserve_no: String!, $mypage_reserve_flag: Int) {
        GetReserveDetail(
          reserve_no: $reserve_no,
          mypage_reserve_flag: $mypage_reserve_flag
        )
        {
            Reserve {
                golf_code
                golf_name
                address
                member_no
                telephone
                reserve_no
                reserve_situation
                reserve_situation_name
                play_date
                cell_number
                play_number
                player_min
                player_left
                plan_name
                plan_id
                total_fee
                detail
                cancel_detail
                course_name
                play_start
                total_fee
                add_fee_2b_weekday
                add_fee_2b_weekend
                add_fee_3b_weekday
                add_fee_3b_weekend
                requestChoice
                reserve_type
                display_course
                member_class
                plan_member_class
                open_flag
                groupInfo {
                    add_fee_2b_weekday
                    add_fee_2b_weekend
                    add_fee_3b_weekday
                    add_fee_3b_weekend
                    cell_id
                    player_number
                    total_fee
                    play_start
                    course_name
                    member
                    # プレイスタイル
                    some_code
                    round_code
                    cart_code
                    caddie_flag
                    meal_flag
                    accommodation_flag
                    competition_flag
                    through_flag
                    lesson_flag
                    reserve_type
                }
                # play_together {
                #     class_no
                #     player_no
                #     member_no
                #     player_name
                # }
                play_style {
                    some_code
                    round_code
                    cart_code
                    cart_on
                    cart_off
                    caddie_flag
                    meal_flag
                    accommodation_flag
                    competition_flag
                    through_flag
                    lesson_flag
                    reserve_type
                }
            }
        }
    }
`;

export const CANCEL_RESERVE_FROM_MYPAGE = gql`
    mutation($reserve_no: String!){
        cancelReserveFromWeb(reserve_no: $reserve_no){
            result
        }
    }
`;

export const UPDATE_PLAY_NUMBER = gql`

    mutation(
        $play_number: Int!
        $reserve_no: String
    ){
    updatePlayerNumber(
        play_number: $play_number
        reserve_no: $reserve_no
    ){
        result
    }
}
`;

export const GET_MAX_RESERVE_BRANCH_NO = gql`

    query (
        $reserve_no: String!
    ){
    GetReserveBranchNo(
        reserve_no: $reserve_no,
    ){
        reserve_branch_no
    }
}
`;

export const GET_MY_PAGE_RESERVE_LIST_INFO = gql`
    query (
        $member_no: ID!
        $reserve_type: Int!
        $limit: Int
        $offset: Int
        $settingGroup: String
        $settingKey: String
    ) {
        GetMypageReserveListInfo(
          member_no: $member_no,
          reserve_type: $reserve_type,
          limit: $limit,
          offset: $offset,
          settingGroup: $settingGroup,
          settingKey: $settingKey
        )
        {
        ReserveList {
            reserve_no
            member_no
            play_date
            golf_code
            golf_name
            plan_id
            plan_name
            play_number
            reserve_situation
            reserve_type
            course_name
            play_start
            cell_number
            play_together_fixed_deadline
            play_style {
                    some_code
                    round_code
                    cart_code
                    cart_on
                    cart_off
                    caddie_flag
                    meal_flag
                    accommodation_flag
                    competition_flag
                    through_flag
                    lesson_flag
                    reserve_type
                    plan_id
                    reserve_situation
            }
        }
        count
        setting_value
        }
    }
`;

export const CANCEL_RESERVE_POINT_FROM_MYPAGE = gql`
    mutation (
        $member_no: ID!
        $golf_code: String
        $reserve_no: String
    ) {
        CancelReservePointFromMypage(
            member_no: $member_no,
            golf_code: $golf_code,
            reserve_no: $reserve_no
        )
        {
            result
        }
    }
`;
